/**
 * Calculate tap indicator position within frame display space
 * 
 * Converts 3D point projection (in image pixel coordinates) to display coordinates
 * for rendering inside the frame div.
 * 
 * @param projectedPixel - The [x, y] pixel coordinate where 3D point projects onto image
 * @param imageWidth - Original image width in pixels (from camera intrinsics)
 * @param imageHeight - Original image height in pixels (from camera intrinsics)
 * @param displayWidth - Current display width of frame in viewport
 * @param displayHeight - Current display height of frame in viewport
 * @returns [displayX, displayY] - Position in display coordinates for indicator rendering
 */
export function calculateIndicatorPosition(
  projectedPixel: [number, number],
  imageWidth: number,
  imageHeight: number,
  displayWidth: number,
  displayHeight: number
): [number, number] {
  // Map from image pixel space to display space
  const displayX = (projectedPixel[0] / imageWidth) * displayWidth
  const displayY = (projectedPixel[1] / imageHeight) * displayHeight
  
  return [displayX, displayY]
}
